module.exports = __webpack_public_path__ + "static/img/6272_phase_function_Paper_PointsHejduk_Prediction.911fb47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6272_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ebPh
// module chunks = 0